// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Modal_overlay__1vZc7","modal-main":"Modal_modal-main__1RMqN","title-bar":"Modal_title-bar__2v1vE","content":"Modal_content__2XUKq","close-btn":"Modal_close-btn__I5wrs"};